import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isCloned", "isReadOnly", "isPreview", "isEmpty", "isDragging", "theme"];
import styled from 'foundations-theming/utils';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
const OccurrencesTableCell = styled.td.withConfig({
  displayName: "OccurrencesTableCell"
})(_ref => {
  let {
      isCloned,
      isReadOnly,
      isPreview,
      isEmpty,
      isDragging,
      theme
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const spaceCssStyles = useMapTokenPropsToCSS(Object.assign({
    padding: '200'
  }, tokenProps));
  return {
    '@keyframes scale-up-center': {
      from: {
        transform: 'scale(0.5)'
      },
      to: {
        transform: 'scale(1)'
      }
    },
    // Double ampersand helps increase specificity to override styles from Table
    '&&': Object.assign({}, spaceCssStyles, {
      height: '37px',
      cursor: 'pointer'
    }, isCloned && {
      animation: 'scale-up-center 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both'
    }, isReadOnly && {
      cursor: 'not-allowed'
    }, isPreview && {
      cursor: 'default'
    }, isEmpty && {
      background: theme.color['fill-field-default'],
      borderRadius: theme.borderRadius['300'],
      cursor: 'default'
    }, isDragging && {
      opacity: 0
    })
  };
});
export default OccurrencesTableCell;